<template>
    <div :class="['row-livechat', 'margin-livechat-5']" >
        <div :class="['col-4', 'col-lg-5', 'pr-0']">
            <div :class="$style.__radio">
                <div :class="$style.__radio__custom">
                    <input  v-model="radioButtonValue" :value="'1'" :id="'radio-1'" :name="'gender'" :type="'radio'" checked="checked">
                    <label :for="'radio-1'" :class="['radio-label']">{{this.$t('input.gender.male')}}</label>
                </div>
                <div :class="$style.__radio__custom">
                    <input   v-model="radioButtonValue" :value="'2'" :id="'radio-2'" :name="'gender'" :type="'radio'" >
                    <label  :for="'radio-2'" :class="['radio-label']">{{this.$t('input.gender.female')}}</label>
                </div>
            </div>
        </div>
        <div :class="['col-8', 'col-lg-7', 'pl-0']">
            <input 
                autofocus="autofocus" 
                data-focus="data-focus"
                :type="'text'" 
                :value="name"
                @input="$emit('input', $event.target.value)"
                :class="['form-control', $style.__input]"  
                :placeholder="[this.$t('input.name')]"
                @keyup="checkWhiteSpace"
            >
        </div>
    </div>
</template>

<style lang="scss" module scoped>
    .__radio, .__email {
        background: #e3e3e3;
        -webkit-border-top-left-radius: 8px;
        -webkit-border-bottom-left-radius: 8px;
        -moz-border-radius-topleft: 8px;
        -moz-border-radius-bottomleft: 8px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        height: 32px;
        border: 1px solid #ccc;
        border-right: 0px;
        width: 100%;
        padding-left: 8px;
        padding-right: 5px;
        padding-top: 6px;
        text-align: left;
    }
    .__radio {
        
        .__radio__custom {
            display: inline;
            margin-right:12px;
            input {
                &[type="radio"] {
                    position: absolute;
                    opacity: 0;
                }
                
                
            }
            input[type="radio"]:checked + label {
                &:before {
                    background-color: #1AABFF;
                    box-shadow: inset 0 0 0 0px #f4f4f4;
                    border: 1px solid #fff;
                }
            }
            label {
                margin:0!important;
                &:before {
                    
                    content: '';
                    background: #f4f4f4;
                    border-radius: 100%;
                    border: 1px solid #b4b4b4;
                    display: inline-block;
                    width:  11px;
                    height: 11px;
                    position: relative;
                    top: 1px;
                    margin-right: 4px;
                    vertical-align: top;
                    cursor: pointer;
                    text-align: center;
                    transition: all 250ms ease;
                    
                }
                padding-left: 0px;
                padding-top: 3px;
                font-size: 12px;
            }
        }
    }
    .__email {
        line-height: 150%;
        .__icon {
            font-size: 14px;
            color:#a7a7a7;
        }
        div {
            font-size: 12px;
            display: inline-block;
            margin-left: 10px;
            position: absolute;
            top: 0;
        }
    }
    .__input {
        height: 32px !important;
        border-left: 0px !important;
        padding: 0 10px !important;
        width: calc(100%) !important;
        -webkit-border-radius: 8px !important;
        -webkit-border-top-left-radius: 0px !important;
        -webkit-border-bottom-left-radius: 0px !important;
        -moz-border-radius: 8px !important;
        -moz-border-radius-topleft: 0px !important;
        -moz-border-radius-bottomleft: 0px !important;
        border-radius: 8px !important;
        border-top-left-radius: 0px !important;
        border-bottom-left-radius: 0px !important;
        font-size: 12px !important;
    }
    @media screen and (min-width: 769px) {
        .__input {
            height: 24px !important;
        }
        .__radio, .__email { 
            height: 24px;
            padding-top: 1px;


        }
        .__radio {
            .__radio__custom {
                label {
                    &:before {
                        width: 8px;
                        height: 8px;
                        top: 3px;
                    }
                }
            }
        }
    }

</style>

<script>

export default {
    props: {
        name: String,
        value : String,
        gender : String
    },
    computed: {
        radioButtonValue: {
            get: function() {
                return 1
            },
            set: function(event) {
                // Communicate the change to parent component so that selectedValue can be updated
                this.$emit("change", event)
            }
        }
    },
    methods : {
        checkWhiteSpace : function (event) {
            event.target.value = event.target.value.trimLeft()
            
        }
    },
    mounted () {
        var form = document.querySelector('#formLiveChat');
        if(form) {
            form.addEventListener('reset', function(event) {
                var autofocusField = form.querySelector('[data-focus]');
                if(autofocusField instanceof HTMLInputElement) {
                    autofocusField.focus();
                }
            });
        }
    },

    
}
</script>